<script>
 
import appConfig from "@/app.config"; 
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

import {
  required,
} from "vuelidate/lib/validators";

/**
 * Form Validation component
 */
export default {
  page: {
    title: "Form Edit room",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Multiselect },
  data() {
    return {
      form: {
        name: null,
        capacity: null,
        description: null,
        location: null
      }, 
      typesubmit: false,
      isError: false,
      errorMessage: null,
      locations: [],
      isLocationNotSelected: false
    };
  },
  validations: {
    form: {
      name: { required },
      capacity: { required }, 
      description: { required } 
    }
  },
  mounted() {
    this.fetchData()
    this.getLocation()
  },
 
  methods: {
    /**
     * Validation type submit
     */
     fetchData() {
      this.$axios.get(`room/${this.$route.params.id}`)
        .then( response => {
          const result = response.data.result
          console.log(result)
          let location = null
          if(result.room.location) {
            result.room.location.locationId = result.room.location._id
            location = result.room.location
          }
          
          this.form = {
            name: result.room.name,
            capacity: result.room.capacity, 
            description: result.room.description,
            location: location
          }
        })
    },
    // eslint-disable-next-line no-unused-vars
    onSubmit(e) {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isError = true
        this.errorMessage = "please fill the form with valid data"
      } else {
        // validation
        this.isLocationNotSelected = this.form.location === null ? true : false;

        if (this.isLocationNotSelected) {
          return false;
        }

        // do your submit logic here
        let param = new FormData();
        param.append('name', this.form.name)
        param.append('capacity', this.form.capacity)
        param.append('description', this.form.description)
        param.append('location', this.form.location.locationId)

        this.$axios.put(`room/${this.$route.params.id}`, param)
        .then( (result) => {  
        if(result){
           Swal.fire("Success", "Room Data Update Success", "success");
          }
        }).catch(e => {
          if (e.response) {  
            this.isError = true
            this.errorMessage = e.response.data.message
          }
        })
      }
    }, 
    getLocation() {
      this.$axios.get(`location`, {
        param: {
          sortBy: "name",
          sortType: 1,
          limit: 100
        }
      }).then((response) => {
          let result = response.data.result.location;
          this.locations = result;
        });
    }
  }
};
</script>

<template>
 
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="isError"
              variant="danger"
              class="mt-3"
              dismissible
            >{{errorMessage}}</b-alert>
            <form action="#" @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Name</label>
                <input
                  v-model="form.name"
                  type="text"
                   
                  class="form-control"
                  name="name"
                  :class="{ 'is-invalid': typesubmit && $v.form.name.$error }"
                />
                <div v-if="typesubmit && $v.form.name.$error" class="invalid-feedback">
                  <span v-if="!$v.form.name.required">This value is required.</span>
                </div>
              </div> 

              <div class="form-group">
                <label>Capacity</label> 
                  <input
                    v-model="form.capacity"
                    type="number"
                    class="form-control"
                    name="capacity"
                    :class="{ 'is-invalid': typesubmit && $v.form.capacity.$error }"
                  />
                <div v-if="typesubmit && $v.form.capacity.$error" class="invalid-feedback">
                  <span v-if="!$v.form.capacity.required">This value is required.</span>
                </div>
              </div> 
              <div class="form-group">
                <label>Deskripsi</label>
                <textarea
                    v-model="form.description"
                    type="text" 
                    class="form-control" 
                    :class="{ 'is-invalid': typesubmit && $v.form.description.$error }"
                  /> 
                <div v-if="typesubmit && $v.form.description.$error" class="invalid-feedback">
                  <span v-if="!$v.form.description.required">This value is required.</span>
                </div>
              </div> 
              <div class="form-group">
                <label>Location</label>
                <multiselect :class="{ 'is-invalid': isLocationNotSelected }" v-model="form.location" deselect-label="Can't remove this value" placeholder="Select one" :options="locations" :searchable="false" :allow-empty="false">
                  <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name | capitalize }}</strong></template>
                  <template slot="option" slot-scope="{ option }"><strong>{{ option.name | capitalize }}</strong></template>
                </multiselect>
                <div v-if="isLocationNotSelected" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div> 
              <div class="form-group mb-0">
                <div>
                  <button type="submit" class="btn btn-primary">Submit</button>
                </div>
              </div>
            </form>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- end col-->
    </div>
    <!-- end row -->
 
</template>